import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import {RadioButton} from '@Components/radio-button';
import styles from './download-adjust-letter-size-option.module.scss';
import {LetterSizeOptionType} from '@Components/download-panel/components/download-adjust-letter-size-option/download-adjust-letter-size-option.types';
import {useDownloadPanelData} from '@Components/download-panel/download-panel.context';

export function DownloadAdjustLetterSizeOption(): ReactElement {
  const {letterSize, setLetterSize} = useDownloadPanelData();
  return (
    <div className="flex flex-v-row">
      <Text val={window.i18next.t('pmwjs_adjust_to_letter_size')} bold size={TextSize.XSMALL} />
      <div>
        <RadioButton
          options={[
            {
              id: LetterSizeOptionType.NO,
              text: window.i18next.t('pmwjs_no'),
            },
            {
              id: LetterSizeOptionType.FIT,
              text: window.i18next.t('pmwjs_fit'),
              tooltipText: window.i18next.t('pmwjs_fit_pdf_description'),
            },
            {
              id: LetterSizeOptionType.STRETCH,
              text: window.i18next.t('pmwjs_stretch'),
              tooltipText: window.i18next.t('pmwjs_stretch_pdf_description'),
            },
          ]}
          containerClasses={styles.container}
          onSelectionCallback={(id: string): void => {
            setLetterSize(id as LetterSizeOptionType);
          }}
          selectionId={letterSize}
        />
      </div>
    </div>
  );
}
